var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',_vm._b({attrs:{"options":_vm.optionsCopy},on:{"filter":_vm.filterFn},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'q-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }